import OtherTransaction from './OtherTransaction.vue';

export default OtherTransaction;